// app.routes.ts
import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { superadminAuthGuard } from './guards/superadmin-auth.guard';

export const routes: Routes = [
  // ========== HOME CON LAYOUT PROPIO ==========
  {
    path: '',
    loadComponent: () => import('./layouts/home-layout/home-layout.component').then(m => m.HomeLayoutComponent),
    pathMatch: 'full',
    data: { title: 'LocalCenter - Inicio' }
  },

  // ========== MÓDULO TIENDA ==========
  {
    path: 'tienda',
    loadComponent: () => import('./layouts/store-layout/store-layout.component').then(m => m.StoreLayoutComponent),
    data: { title: 'LocalCenter - Tienda' },
    loadChildren: () => import('./modules/store/store.routes').then(m => m.STORE_ROUTES)
  },

  // ========== MÓDULO CAJA (POS) ==========
  {
    path: 'caja',
    loadComponent: () => import('./layouts/cajero-layout/cajero-layout.component').then(m => m.CajeroLayoutComponent),
    data: { title: 'LocalCenter - Caja' },
    loadChildren: () => import('./modules/cajero/cajero.routes').then(m => m.CAJERO_ROUTES)
  },

  // ========== MÓDULO REPARTIDOR (PWA) ==========
  {
    path: 'repartidor',
    loadComponent: () => import('./layouts/repartidor-layout/repartidor-layout.component').then(m => m.RepartidorLayoutComponent),
    data: { title: 'LocalCenter - Repartidor' },
    loadChildren: () => import('./modules/repartidor/repartidor.routes').then(m => m.REPARTIDOR_ROUTES)
  },

  // ========== MÓDULO VENDEDOR ==========
  {
    path: 'vendedor',
    children: [
      {
        path: 'login',
        loadComponent: () => import('./pages/vendedor/vendedor-login/vendedor-login.component').then(m => m.VendedorLoginComponent),
        data: { title: 'Vendedor - Iniciar Sesion' }
      },
      {
        path: '',
        loadComponent: () => import('./layouts/vendedor-layout/vendedor-layout.component').then(m => m.VendedorLayoutComponent),
        loadChildren: () => import('./modules/vendedor/vendedor.routes').then(m => m.VENDEDOR_ROUTES)
      }
    ]
  },

  // ========== PRICING PUBLICO ==========
  {
    path: 'precios',
    loadComponent: () => import('./pages/pricing/pricing.component').then(m => m.PricingComponent),
    data: { title: 'LocalCenter - Precios' }
  },

  // ========== TRACKING PUBLICO ==========
  {
    path: 'tracking',
    data: { title: 'LocalCenter - Seguimiento' },
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/tracking/tracking-entrega/tracking-entrega.component').then(m => m.TrackingEntregaComponent),
        data: { title: 'LocalCenter - Seguimiento de Entrega' }
      },
      {
        path: ':codigo',
        loadComponent: () => import('./pages/tracking/tracking-entrega/tracking-entrega.component').then(m => m.TrackingEntregaComponent),
        data: { title: 'LocalCenter - Seguimiento de Entrega' }
      }
    ]
  },

  {
    path: 'login',
    loadComponent: () => import('./pages/auth/login/login.component').then(m => m.LoginComponent),
    data: { title: 'LocalCenter - Iniciar Sesión' }
  },
  {
    path: 'auth/google/callback',
    loadComponent: () => import('./pages/auth/google-callback/google-callback.component').then(m => m.GoogleCallbackComponent),
    data: { title: 'LocalCenter - Iniciando sesión', preload: false }
  },
  {
    path: 'auth/forgot-password',
    loadComponent: () => import('./pages/auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
    data: { title: 'LocalCenter - Recuperar Contraseña' }
  },
  {
    path: 'auth/reset-password',
    loadComponent: () => import('./pages/auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
    data: { title: 'LocalCenter - Restablecer Contraseña' }
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/auth/solicitud-registro/solicitud-registro.component').then(m => m.SolicitudRegistroComponent),
    data: { title: 'LocalCenter - Solicitar Acceso' }
  },

  // ========== SUPERADMIN ==========
  {
    path: 'superadmin/login',
    loadComponent: () => import('./pages/superadmin/superadmin-login/superadmin-login.component').then(m => m.SuperadminLoginComponent),
    data: { title: 'SuperAdmin - Login' }
  },
  {
    path: 'superadmin',
    loadComponent: () => import('./layouts/superadmin-layout/superadmin-layout.component').then(m => m.SuperadminLayoutComponent),
    canActivate: [superadminAuthGuard],
    loadChildren: () => import('./modules/superadmin/superadmin.routes').then(m => m.SUPERADMIN_ROUTES)
  },

  // ========== ONBOARDING (fullscreen, sin layout) ==========
  {
    path: 'onboarding',
    loadComponent: () => import('./pages/onboarding/onboarding.component').then(m => m.OnboardingComponent),
    canActivate: [authGuard],
    data: { title: 'LocalCenter - Configuracion Inicial' }
  },

  // ========== MÓDULO PRINCIPAL (ADMIN/APP) ==========
  {
    path: '',
    loadComponent: () => import('./layouts/main-layout/main-layout.component').then(m => m.MainLayoutComponent),
    children: [
      {
        path: 'access-denied',
        loadComponent: () => import('./components/access-denied/access-denied.component').then(m => m.AccessDeniedComponent),
        data: { title: 'LocalCenter - Acceso Denegado' }
      },
      {
        path: 'excel-uploader',
        loadComponent: () => import('./components/excel-uploader/excel-uploader.component').then(m => m.ExcelUploaderComponent),
        canActivate: [authGuard],
        data: { title: 'LocalCenter - Cargar Excel' }
      },
      {
        path: 'gestion-stock',
        loadComponent: () => import('./components/gestion-stock/gestion-stock.component').then(m => m.GestionStockComponent),
        canActivate: [authGuard],
        data: { title: 'LocalCenter - Gestión de Stock' }
      },
      {
        path: 'pdf-customizer',
        loadComponent: () => import('./components/pdf-customizer/pdf-customizer.component').then(m => m.PdfCustomizerComponent),
        canActivate: [authGuard],
        data: {
          title: 'LocalCenter - Personalizar PDF',
          subscriptionRequired: 'basic'
        }
      },
      {
        path: 'pdf-preview',
        loadComponent: () => import('./components/pdf-preview/pdf-preview.component').then(m => m.PdfPreviewComponent),
        canActivate: [authGuard],
        data: { title: 'LocalCenter - Vista Previa PDF' }
      },
      {
        path: 'productos',
        loadComponent: () => import('./pages/admin/productos/producto-lista/producto-lista.component').then(m => m.ProductoListaComponent),
        canActivate: [authGuard],
        data: { title: 'LocalCenter - Productos' }
      },
      {
        path: 'productos/nuevo',
        loadComponent: () => import('./pages/admin/productos/producto-edit/producto-edit.component').then(m => m.ProductoEditComponent),
        canActivate: [authGuard],
        canDeactivate: [(component: any) => component.canDeactivate()],
        data: {
          title: 'LocalCenter - Nuevo Producto',
          permissions: ['create_product']
        }
      },
      {
        path: 'productos/editar/:id',
        loadComponent: () => import('./pages/admin/productos/producto-edit/producto-edit.component').then(m => m.ProductoEditComponent),
        canActivate: [authGuard],
        canDeactivate: [(component: any) => component.canDeactivate()],
        data: {
          title: 'LocalCenter - Editar Producto',
          permissions: ['edit_product']
        }
      },
      {
        path: 'generar-catalogo',
        loadComponent: () => import('./components/catalogo-generator/catalogo-generator.component').then(m => m.CatalogoGeneratorComponent),
        canActivate: [authGuard],
        data: {
          title: 'LocalCenter - Generar Catálogo',
          permissions: ['generate_catalog'],
          subscriptionRequired: 'premium'
        }
      },
      {
        path: 'perfil',
        loadComponent: () => import('./pages/perfil/perfil.component').then(m => m.PerfilComponent),
        canActivate: [authGuard],
        data: { title: 'LocalCenter - Mi Perfil' }
      },
      {
        path: 'upgrade-subscription',
        loadComponent: () => import('./components/upgrade-subscription/upgrade-subscription.component').then(m => m.UpgradeSubscriptionComponent),
        canActivate: [authGuard],
        data: { title: 'LocalCenter - Actualizar Suscripción' }
      },
      {
        path: 'checkout',
        loadComponent: () => import('./components/checkout/checkout.component').then(m => m.CheckoutComponent),
        canActivate: [authGuard],
        data: { title: 'LocalCenter - Checkout' }
      },
      // ========== REPORTES (redirects a /admin/reportes) ==========
      { path: 'reportes/dashboard', redirectTo: 'admin/reportes', pathMatch: 'full' },
      { path: 'reportes/ventas', redirectTo: 'admin/reportes', pathMatch: 'full' },
      { path: 'reportes/iva', redirectTo: 'admin/reportes', pathMatch: 'full' },
      { path: 'reportes/stock', redirectTo: 'admin/reportes', pathMatch: 'full' },
      { path: 'reportes/finanzas', redirectTo: 'admin/reportes', pathMatch: 'full' },
      { path: 'reportes/crm', redirectTo: 'admin/reportes', pathMatch: 'full' },
      { path: 'reportes/reparto', redirectTo: 'admin/reportes', pathMatch: 'full' },
      { path: 'reportes/rentabilidad', redirectTo: 'admin/reportes', pathMatch: 'full' },
      {
        path: 'admin',
        loadChildren: () => import('./modules/admin/admin.routes').then(m => m.ADMIN_ROUTES),
        canActivate: [authGuard],
        data: {
          title: 'LocalCenter - Administración',
          roles: ['admin', 'supervisor', 'cajero', 'vendedor', 'super_admin', 'SuperAdmin', 'EmpresaAdmin']
        }
      },
    ]
  },
  { 
    path: '**', 
    redirectTo: '',
    data: { title: 'LocalCenter - Página no encontrada' }
  } 
];